import { render } from "./GrowthMonitoringModal.vue?vue&type=template&id=0848d190&scoped=true"
import script from "./GrowthMonitoringModal.vue?vue&type=script&lang=js"
export * from "./GrowthMonitoringModal.vue?vue&type=script&lang=js"

import "./GrowthMonitoringModal.vue?vue&type=style&index=0&id=0848d190&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/CBHI/PONA HEALTH/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0848d190"]])

export default __exports__